export default (html: string): string =>
  html.replace(/<img([^>]*)data-src="([^"]*)"/g, '<img$1src="$2" loading="lazy"');
